module.exports = __webpack_public_path__ + "c74f4c50d7245f286115a0ee714e4e56.svg";